import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import emailjs from '@emailjs/browser';
import Lottie from "lottie-react";
import animationData from "../../Assets/Animation.json";

function Contact() {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ message: '', isError: false });

  useEffect(() => {
    emailjs.init("sx-MgxlamMvpNO4M8");
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ message: '', isError: false });

    emailjs.sendForm(
      'service_i6youec',
      'template_zlha5hu',
      form.current,
      'sx-MgxlamMvpNO4M8'
    )
      .then((result) => {
        setSubmitStatus({
          message: 'Message sent successfully!',
          isError: false
        });
        form.current.reset();
      })
      .catch((error) => {
        setSubmitStatus({
          message: 'Failed to send message. Please try again.',
          isError: true
        });
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };




  return (
    <Container fluid className="contact-section" id="contact">
      <Container>
        <div className="contact-header">
          <h1 className="contact-heading">Contact Me</h1>
          <h2 className="contact-subheading">Open to DevOps, cloud, backend, and ML infrastructure opportunities.</h2>
          <div className="contact-divider">
            <span></span>
          </div>
        </div>

        <div className="contact-card">
          <Row className="align-items-center">
            <Col md={5} className="contact-left-side">
              <div className="contact-info-block">
                <h3 className="contact-info-title">Let's Connect!</h3>
                <p className="contact-info-text">
                  Feel free to reach out about platform engineering, cloud infrastructure, backend systems,
                  or practical AI projects.
                </p>
                <div className="social-icons-grid">
                  <a
                    href="https://github.com/YaoyiW27"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-social-icon"
                  >
                    <AiFillGithub />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/yaoyiw20010527/"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-social-icon"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="mailto:rmwyyy@gmail.com"
                    className="contact-social-icon"
                  >
                    <MdEmail />
                  </a>
                </div>
                <div className="contact-animation">
                  <Lottie
                    animationData={animationData}
                    loop={true}
                    className="lottie-animation"
                  />
                </div>
              </div>
            </Col>

            <Col md={7}>
              <form ref={form} onSubmit={sendEmail} className="contact-form">
                <div className="form-group">
                  <input
                    type="text"
                    name="user_name"
                    placeholder="Name"
                    className="contact-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    name="user_email"
                    placeholder="Email"
                    className="contact-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Message"
                    className="contact-input contact-textarea"
                    required
                  ></textarea>
                </div>
                {submitStatus.message && (
                  <div className={`submit-status ${submitStatus.isError ? 'error' : 'success'}`}>
                    {submitStatus.message}
                  </div>
                )}
                <button
                  type="submit"
                  className="contact-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send'}
                  <span>➔</span>
                </button>
              </form>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
}

export default Contact;
